import { Account } from "../domain/Account";
import { AccountRepository } from "../domain/AccountRepository";

export function listAccountsByCompanyUid(
  accountRepository: AccountRepository,
  companyUid: string
): Promise<Account[]> {
  return accountRepository.getAccountsByCompanyUid(companyUid);
}
